import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { CatalogEditDraft, CatalogKind } from '@/types/catalog.ts';
import CatalogList from '@/components/catalog/CatalogList.tsx';
import CatalogPendingDraftsBanner from '@/components/catalog/CatalogPendingDraftsBanner.tsx';

const KIND_TABS: CatalogKind[] = ['Sector', 'SubSector', 'SalePhase', 'PriceRange', 'SimulationType', 'Difficulty'];

export default function SuperUserCatalogPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeKind, setActiveKind] = useState<CatalogKind>('Sector');

  function handleDraftCreated(draft: CatalogEditDraft) {
    navigate(`/superuser/catalog/edits/${draft.id}`);
  }

  return (
    <div className="animate-fade-in">
      <div className="mb-6">
        <h1 className="text-2xl font-heading text-foreground">
          {t('superuser.catalog.title', { defaultValue: 'Catálogo editorial' })}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t('superuser.catalog.subtitle', {
            defaultValue: 'Gestiona los catálogos compartidos entre managers. Cambios pasan por traducción IA + revisión humana.',
          })}
        </p>
      </div>

      <CatalogPendingDraftsBanner />

      <div className="mb-4 flex flex-wrap gap-1 rounded-lg border border-border bg-card p-1">
        {KIND_TABS.map((kind) => (
          <button
            key={kind}
            type="button"
            onClick={() => setActiveKind(kind)}
            className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
              activeKind === kind
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {t(`superuser.catalog.tabs.${kind}`, { defaultValue: kind })}
          </button>
        ))}
      </div>

      <CatalogList kind={activeKind} onDraftCreated={handleDraftCreated} />
    </div>
  );
}
